import React, { useState, useEffect } from 'react';
import {
  Row, Input, Button, Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { postAPI_Create_Question_Option, putAPI_Update_Question_Option } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';


function QuestionOptionForm({
  /** Globle property id from redux */
  propertyId,
  QuestionId,
  CancelQuestionOption,
  loadResponse,
  optionName,
  Id,
  updateOption
}) {
  const [buttonTextInput, setButtonTextInput] = useState(optionName == undefined ? '' : optionName)
  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    PropertyId: propertyId,
    QuestionId: QuestionId,
    Option: '',
    DisplayOrder: 1,
    Status: 'Active',
    Creator: 'API'
  });

  useEffect(() => {
    setPostData({ ...postData, Option: buttonTextInput })
  }, [buttonTextInput]);

  const handleCaptionChange = e => {
    setButtonTextInput(e.target.value);
  };

  const handleSave = async () => {
    if (Id === undefined) {
      try {
        return await AxiosAPI({
          method: 'post',
          url: `${postAPI_Create_Question_Option}`,
          data: postData,
        })
          .then(() => {
            console.log("added")
          })
          .finally(
            setTimeout(() => {
              CancelQuestionOption();
              loadResponse();
            }, 1000)
          );
      } catch (error) {
        console.error(error);
      }
    }
    else {
      let data = {
        Option: buttonTextInput,
        Status: 'Active',
        Updater: 'Dashboard',
        DisplayOrder: 1
      }
      try {
        return await AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_Question_Option}/${Id}`,
          data: data,
        })
          .then(() => {
            console.log("added")
          })
          .finally(
            setTimeout(() => {
              updateOption(buttonTextInput)
            }, 1000)
          );
      } catch (error) {
        console.error(error);
      }
    }

  };

  const handleCancel = () => {
    CancelQuestionOption();
    // if (setIsEditingToFalse) {
    //   setIsEditingToFalse();
    // }
    // if (setIsAddImageToFalse) {
    //   setIsAddImageToFalse();
    // }
    // toggleButtonAddedd();
    // toggleButtonMessageAddedd();
  };
  return (
    <div>
      <Row>
        {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}

        <Colxx xxs="12">
          <Input
            type="text"
            value={buttonTextInput}
            onChange={handleCaptionChange}
          ></Input>
        </Colxx>
      </Row>
      <Row>

        <Colxx xxs="12">
          <div
            className="float-right"
            style={{ marginTop: ' 5px', marginBottom: '5px' }}
          >

            <Button
              color="secondary"
              className="add-button"
              size="xs"
              onClick={handleSave}
            >
              Save
            </Button>
            <b> </b>
            <Button
              color="light"
              className="add-button"
              size="xs"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </Colxx>
      </Row>

    </div>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps)(QuestionOptionForm));
